import React from "react";
import ActionDialog from "../../ActionDialog";
import { ContractAgentByUser } from "../../ContractAgentByUser";

const ReadAgreementDialog = ({ open, onClose, user, currentUser }) => (
  <ActionDialog
    title={`app.contractAgent.readAgreement.${user.contractAgent?.contractAgentClass?.levelName}`}
    open={open}
    onClose={onClose}
    maxWidth="xl"
    enableConfirmButton={false}
  >
    <ContractAgentByUser
      user={user}
      locale={currentUser.locale}
    />
  </ActionDialog>
);

export default ReadAgreementDialog;
